import { ColumnDef } from "@tanstack/react-table"
import { NilonLevelTableDataItem } from "types/NilonLevelTableTypes"
import Const from 'const.json'
import React from "react"
import { COMPLAINTS_LIMIT, numberWithCommas, toIntSafe } from "utils/utils"

const Columns = (): ColumnDef<NilonLevelTableDataItem, any>[] => {
    const c = Object.keys(Const.nilonLevelTableKeys).map((key) => {
        if (key === "description")
            return {
                accessorKey: key,
                header: ({ table }) => <>{Const.nilonLevelTableKeys[key]}</>,
                cell: ({ row, getValue }) => (
                    <div>
                        <div>
                            {row.original.children?.length && row.getCanExpand() ? (
                                <span
                                    {...{
                                        onClick: row.getToggleExpandedHandler(),
                                        style: { cursor: "pointer", width: "100%" },
                                    }}
                                >
                                    {row.getIsExpanded() ? (
                                        <span onClick={() => row.toggleExpanded()}>&and;</span>
                                    ) : (
                                        <span onClick={() => row.toggleExpanded()}>&or;</span>
                                    )}
                                </span>
                            ) : (
                                ""
                            )}{" "}
                            {getValue()}
                        </div>
                    </div>
                ),
            };
        return {
            accessorKey: key,
            header: `${Const.nilonLevelTableKeys[key]}`,
            cell: ({ row, getValue }) => (<>{row.original.complaintCount >= COMPLAINTS_LIMIT ? (numberWithCommas(toIntSafe(getValue())) || 0) : `${Const.smallerThan} ${COMPLAINTS_LIMIT}`}</>)
        };
    });
    return c;
}

export default Columns